module.exports = __webpack_public_path__ + "img/ico_checked.0d4e6672.png";